import { cn } from '@/lib/utils';
import { ComponentProps } from 'react';

export const Container = ({ className, ...props }: ComponentProps<'div'>) => {
  return (
    <div className={cn('px-3', className)}>
      <div className="max-w-[960px] pt-8 pb-24 md:pb-20 mx-auto" {...props} />
    </div>
  );
};
